import router from "@/router/index";
import APP_ERROR_CODES from "@/assets/data/errorCodes.js";
import { useErrorStore } from "@/stores/components/errorStore";

export default () => {
  function handleServerErrors(error) {
    const { code, message, status, statusText } = error.response.data;

    const errorCode = status || code;
    const errorMsg = statusText || message;

    storeErrorInStore(errorCode, errorMsg); 

    router.push({
      name: "error",
    });
  }

  function handleMappedErrorResponses(code, errors) {
    const { field, error, callback } = APP_ERROR_CODES.get(code) || {};
    if (callback) {
      callback();
    }

    return field || error ? { field, error } : null;
  }

  function handleErrorInSpaFlow(code, message) {
    
    storeErrorInStore(code, message);
    
    router.push({
      name: "error",
    });
  }

  function storeErrorInStore(errorCode, errorMessage) {
    const error = useErrorStore(); 
    error.$state.error.code = errorCode;
    error.$state.error.message = errorMessage;
  }

  return {
    handleServerErrors,
    handleMappedErrorResponses,
    handleErrorInSpaFlow,
  };
};
